import ArticleCardAuthorRow from "../articleCardComponents/articleCardAuthorRow";
import StoryblokImageBasic from "../storyblokImageBasic/storyblokImageBasic";
import LegacyThumbnail from "../legacyThumbnail/legacyThumbnail";
import Tag from "../tag/tag";

import { formatArticleDate } from "../../helpers/dateHelper";

import styles from "./SearchCard.module.scss";
import RouterLink from "../link/RouterLink";
import { buildInternalPath } from "../../helpers/URLHelpers";

function SearchCard({
  slug,
  title,
  lead,
  image,
  date,
  article_type,
  article_category,
  authors,
  enable_comments,
  comment_count,
  enable_social_sharing,
  use_legacy_thumbnail_background,
}) {
  const link = buildInternalPath(slug);
  return (
    <article className={styles.searchCard}>
      <div>
        <div className={styles.thumbnail}>
          {use_legacy_thumbnail_background ? (
            <LegacyThumbnail to={link} thumbnail_image={image} width={576} />
          ) : (
            <>
              {image && image.filename ? (
                <RouterLink
                  to={link}
                  className={styles.defaultThumbnail}
                >
                  <StoryblokImageBasic width={576} image={image} />
                </RouterLink>
              ) : null}
            </>
          )}
        </div>
      </div>
      <div>
        {/* Render Tags */}
        {renderTags(article_type, article_category, date)}
        {title ? (
          <h3 className={styles.title}>
            <RouterLink to={link}>{title}</RouterLink>
          </h3>
        ) : null}
        {lead ? <p className={styles.summary}>{lead}</p> : null}
        <ArticleCardAuthorRow
          withClass={styles.authorRow}
          withCommentsClassName={styles.comments}
          withShareClassName={styles.share}
          withAuthorClass={styles.author}
          authors={authors}
          enableComments={enable_comments}
          enableSocialSharing={enable_social_sharing}
          commentCount={comment_count}
        />
      </div>
    </article>
  );
}

function renderTags(articleType, articleCategory, date) {
  return (
    <div className={styles.tagsAndDate}>
      <div className={styles.tags}>
        {articleCategory ? (
          <RouterLink to={buildInternalPath(articleCategory.slug)}>
            <Tag withClass={styles.tag} label={articleCategory.content.title} />
          </RouterLink>
        ) : null}
        {articleType ? (
          <RouterLink to={buildInternalPath(articleType.slug)}>
            <Tag withClass={styles.tag} label={articleType.content.title} />
          </RouterLink>
        ) : null}
      </div>
      {date ? (
        <div className={styles.date}>{formatArticleDate(date)}</div>
      ) : null}
    </div>
  );
}

export default SearchCard;
